<template>
  <el-dialog
    :title="'Ghép nhóm'"
    :visible.sync="dialogJoinGroupVisible"
    width="90%"
    :close-on-click-modal="false"
  >
    <MergeDataTableForJoinGroup
      v-model="resultData"
      :result-template="resultTemplate"
      :header-list="headerList"
      :selected-list="data"
      id-header="booking_code"
    />

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small" @click="onJoinGroup">
          {{ $t('config.profile.common.agree') }}
        </button>
        <button
          class="btn primary small outline"
          @click="dialogJoinGroupVisible = false"
        >
          {{ $t('config.profile.common.cancel') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { joinGroup } from '@/api/reception/reception'
import MergeDataTableForJoinGroup from './MergeDataTableForJoinGroup.vue'
import { notifyError, notifySuccess } from '@/utils/toast'

export default {
  components: { MergeDataTableForJoinGroup },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array
    },
    groupCode: {
      type: String
    }
  },
  data() {
    return {
      resultData: null,
      resultTemplate: {
        note: null,
        booking_code: null,
        booking_code_1: null,
        booking_code_2: null,
        booker_id: 0,
        booker_code: null,
        agent_id: 0,
        agent_name: null,
        market_seg_id: 0,
        market_seg_code: null,
        debit_account_id: 0,
        debit_account: null,
        source_id: 0,
        source_code: null,
        sales_person_id: 0,
        sales_person_name: null,
        release_date: null,
        depart_time: null,
        vehicle: null,
        license_plate: null,
        arrival_time: null,
        pay_method: 0,
        commission_percent: 0,
        commission_fee: 0,
        group_code: null, // uu tien group booking code than customer booking code
        credit_card: null,
        credit_card_owner: null,
        expired_credit_card: null,
        invoice_agent_name: null,
        invoice_address: null,
        invoice_tax: null,
        invoice_phone: null,
        invoice_email: null,
        special_command: null,
        e_invoice: true,
        booking_status: 0
      }
    }
  },
  computed: {
    headerList() {
      return [
        // Đặt phòng
        { text: 'Đặt phòng', value: 1, isGroupTitle: true },
        { text: 'Mã nhóm', value: 'group_code' },

        // Thông tin người đặt
        { text: 'Thông tin người đặt', value: 2, isGroupTitle: true }, // 2 row in group
        { text: 'ID đặt phòng', value: 'booker_id' },
        { text: 'Mã đặt phòng', value: 'booker_code' },

        // Thống kê
        { text: 'Thống kê', value: 12, isGroupTitle: true }, // 12 row in group
        { text: 'ID công ty, đại lý du lịch', value: 'agent_id' },
        { text: 'Công ty, đại lý du lịch', value: 'agent_name' },
        { text: 'ID phân khúc thị trường', value: 'market_seg_id' },
        { text: 'Phân khúc thị trường', value: 'market_seg_code' },
        { text: 'ID tài khoản công nợ', value: 'debit_account_id' },
        { text: 'Tài khoản công nợ', value: 'debit_account' },
        { text: 'ID nguồn', value: 'source_id' },
        { text: 'Nguồn', value: 'source_code' },
        { text: 'ID Nhân viên tạo đặt phòng', value: 'sales_person_id' },
        { text: 'Nhân viên tạo đặt phòng', value: 'sales_person_name' },
        { text: 'Hoa hồng (%)', value: 'commission_percent' },
        { text: 'Hoa hồng (Tiền)', value: 'commission_fee' },

        // Thông tin thanh toán
        { text: 'Thông tin thanh toán', value: 4, isGroupTitle: true }, // 4 row in group
        { text: 'Phương thức thanh toán', value: 'pay_method' },
        { text: 'Thẻ tín dụng', value: 'credit_card' },
        { text: 'Chủ thẻ', value: 'credit_card_owner' },
        { text: 'Ngày hết hạn', value: 'expired_credit_card' },

        // Thông tin đặt phòng
        { text: 'Thông tin đặt phòng', value: 4, isGroupTitle: true }, // 4 row in group
        { text: 'Thời gian đi', value: 'depart_time' },
        { text: 'Phương tiện', value: 'vehicle' },
        { text: 'Biển số xe', value: 'license_plate' },
        { text: 'Thời gian đến', value: 'arrival_time' },

        // Thông tin hóa đơn
        { text: 'Thông tin hóa đơn', value: 7, isGroupTitle: true }, // 7 row in group
        { text: 'Tên công ty trên hóa đơn', value: 'invoice_agent_name' },
        { text: 'Địa chỉ', value: 'invoice_address' },
        { text: 'Mã số thuế', value: 'invoice_tax' },
        { text: 'Số điện thoại', value: 'invoice_phone' },
        { text: 'Email', value: 'invoice_email' },
        { text: 'Yêu cầu đặc biệt', value: 'special_command' },
        { text: 'Hoá đơn điện tử', value: 'e_invoice' }
      ]
    },
    dialogJoinGroupVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    onJoinGroup() {
      this.resultData = {
        ...this.resultData,
        // TODO: change input
        group_code: this.groupCode,
        booking_code_1: this.data[0].booking_code,
        booking_code_2: this.data[1].booking_code,
        booking_code: null
      }

      // console.log('merge req', this.resultData)

      if (this.resultData) {
        joinGroup(this.resultData)
          .then(data => {
            if (!data.is_error) {
              notifySuccess(data.message)
              this.$emit('resetSearch')
              // close dialog
              this.dialogJoinGroupVisible = false
            } else {
              throw new Error(data)
            }
          })
          .catch(error => {
            notifyError(error.response?.data?.message)
          })
          .finally(() => {})
      }
    }
  }
}
</script>
